import { Button, Collapse, Modal } from "components/Core"
import { Datepicker } from "flowbite-react"
import { format_date } from "helpers/datetime_helper"
import usePreRender from "hooks/usePreRender"
import { useCallback, useContext, useEffect, useRef, useState } from "react"
import { addDays, subDays, differenceInDays } from "date-fns"
import { MdOutlineClose } from "react-icons/md"
import { AppContext } from "store/context/AppContext"

interface IFieldDate {
  field: any
  apply_filter: any
}

const FieldDate = ({ field: _field, apply_filter }: IFieldDate) => {
  const { filters_table } = useContext(AppContext)
  const { id, label } = _field
  const [range_date, set_range_date] = useState<{ initial: Date; final: Date }>({
    initial: new Date(),
    final: new Date(),
  })
  const { _color } = usePreRender()
  const modal_ref = useRef<any>(null)

  useEffect(() => {
    if (Object.keys(filters_table.state).length === 0) {
      set_range_date({ initial: new Date(), final: new Date() })
    }
  }, [filters_table.state])

  const handleClickCalendarOpen = useCallback(() => modal_ref.current.open(), [])

  const handleClickCalendarClose = useCallback(() => modal_ref.current.close(), [])

  const apply_filter_range_date = () => {
    apply_filter({
      ..._field,
      value: {
        from: `${format_date(range_date.initial)}T00:00:00.000Z`,
        to: `${format_date(range_date.final)}T23:59:59.000Z`,
      },
    })
  }

  return (
    <>
      <Modal ref={modal_ref} localIconClose>
        <div className="flex flex-col w-96">
          <div className={`relative w-full text-center bg_${_color} rounded-t-xl p-2`}>
            <h4 className="text-lg font-medium uppercase text-white">{label}</h4>
            <MdOutlineClose
              className="absolute top-2 right-2 text-xl text-white hover:text-red-600 cursor-pointer"
              onClick={() => modal_ref.current.close()}
            />
          </div>
          <div className="w-full flex flex-col rounded-b-xl gap-4 px-4 py-6">
            <div className="w-full flex flex-col gap-2">
              <p>Desde:</p>
              {!!_field.maxAndMinDays ? (
                <Datepicker
                  language="es"
                  value={format_date(range_date.initial)}
                  onSelectedDateChanged={(date: any) => {
                    set_range_date({ ...range_date, initial: date, final: date })
                  }}
                  showClearButton={false}
                  showTodayButton={false}
                  open
                />
              ) : (
                <Datepicker
                  language="es"
                  value={format_date(range_date.initial)}
                  onSelectedDateChanged={(date: any) => set_range_date({ ...range_date, initial: date })}
                  showClearButton={false}
                  showTodayButton={false}
                  open
                />
              )}
              <p>Hasta:</p>
              {!!_field.maxAndMinDays ? (
                <Datepicker
                  language="es"
                  value={format_date(range_date.final)}
                  onSelectedDateChanged={(date: any) => {
                    const _diff_days = differenceInDays(date, range_date.initial)
                    console.log(_diff_days)
                    set_range_date({ ...range_date, final: date })
                  }}
                  showClearButton={false}
                  showTodayButton={false}
                  minDate={subDays(range_date.initial, _field.maxAndMinDays)}
                  maxDate={addDays(range_date.initial, _field.maxAndMinDays)}
                />
              ) : (
                <Datepicker
                  language="es"
                  value={format_date(range_date.final)}
                  onSelectedDateChanged={(date: any) => set_range_date({ ...range_date, final: date })}
                  showClearButton={false}
                  showTodayButton={false}
                />
              )}
              <div className="flex flex-row items-center justify-end">
                <button
                  onClick={() => {
                    handleClickCalendarClose()
                    apply_filter_range_date()
                  }}
                  type="button"
                  className={`py-2 px-4 text-center bg_${_color} text-white font-medium rounded-lg hover:opacity-90`}
                >
                  Aplicar
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Collapse name={id} header={<h1>{label}</h1>}>
        <div className="w-full flex flex-row items-center justify-center gap-2">
          <div
            className="flex flex-row items-center justify-start w-full h-12 px-2 border rounded-md border-gray-300 bg-gray-50 text-gray-900 text-sm cursor-pointer"
            onClick={handleClickCalendarOpen}
          >
            <p>{`${format_date(range_date.initial)}, ${format_date(range_date.final)}`}</p>
          </div>
          <Button label="Aplicar" className="w-28 !p-0" onClick={apply_filter_range_date} />
        </div>
      </Collapse>
    </>
  )
}

export default FieldDate
